/* eslint-disable import/prefer-default-export */
// @flow
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { ReminderProps } from 'types/reminders'

export async function listReminders(
  requestParams: any
): Promise<ReminderProps[]> {
  return makeGetRequest(`${ApiBase}/reminders/`, requestParams)
}

export async function getGlobalReminder(): Promise<ReminderProps> {
  return makeGetRequest(`${ApiBase}/reminders/?global=true`)
}
